import * as actionTypes from "../../actions/ArkchatGroup/type";

const initState = {
  firstGroup: {},
  groupList: [],
  cloneGroupList: [],
  isLoading: false,
  groupmember: null,
  accountLevelPeople: null,
  allWorkspacePeople: null,
  groupmemberWithPermission: null,
  attachmentData: {},
  messageList: [],
  allGroupInvite: [],
  allGroupAnalytics: [],
  tempMessageList: [],
  threadMsgList: [],
  starMsgData: [],
  cloneGroupMessageList: [],
  taskList: [],
  approvalList: [],
  workTrackingList: [],
  workTrackingThreadParents: {},
  taskAnalyticsData: [],
  approvalAnalyticsData: [],
  aiQuerySession: [],
  aiHistoryData: [],
  likeUserList: [],
  groupRecipient: [],
};

export const arkchatgroupReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes?.REQUEST_CREATE_FIRST_GROUP:
      return {
        ...state,
        firstGroup: action?.payload,
      };
    case actionTypes?.REQUEST_ALL_GROUP:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes?.RECEIVED_ALL_GROUP_SUCCESS:
      return {
        ...state,
        groupList: action?.payload,
        cloneGroupList: action?.payload,
        isLoading: false,
      };
    case actionTypes?.REQUEST_ALL_GROUP_INVITE:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes?.RECEIVED_ALL_GROUP_INVITE_SUCCESS:
      return {
        ...state,
        allGroupInvite: action?.payload,
        isLoading: false,
      };

    case actionTypes?.FAILED_ALL_GROUP_INVITE:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes?.REQUEST_ALL_GROUP_ANALYTICS:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes?.REQUEST_ALL_GROUP_ANALYTICS_SUCCESS:
      return {
        ...state,
        allGroupAnalytics: action?.payload,
        isLoading: false,
      };

    case actionTypes?.FAILED_ALL_GROUP_ANALYTICS:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes?.RECEIVED_ALL_ARCHIVE_GROUP_SUCCESS:
      return {
        ...state,
        archiveGroupList: action?.payload,
        isLoading: false,
      };
    case actionTypes?.RECEVED_GROUDP_MEMBER_SUCCESS:
      return {
        ...state,
        groupmember: action?.payload,
      };
    case actionTypes?.GROUDP_RECIPIENT_DETAILS:
      return {
        ...state,
        groupRecipient: action?.payload,
        // Which group they're for (signal updates are for the open group).
        groupRecipientGroupId: action?.groupId ?? state.groupRecipientGroupId,
      };

    case actionTypes.RECEIVED_GROUP_FILTER:
      return {
        ...state,
        groupList: action?.payload,
      };
    case actionTypes.UPDATE_GROUP_LIST_ORDER:
      return {
        ...state,
        groupList: action?.payload,
        cloneGroupList: action?.payload,
      };
    case actionTypes.RECEIVED_USER_WITH_PERMISSION:
      return {
        ...state,
        groupmemberWithPermission: action?.payload,
      };

    case actionTypes?.RECEIVED_ALL_WORKSPACE_PEOPLE:
      return {
        ...state,
        allWorkspacePeople: action?.payload,
      };
    case actionTypes?.RECEIVED_ONBOARDING_ACCOUNT_MEMBER:
      return {
        ...state,
        accountLevelPeople: action?.payload,
      };
    case actionTypes?.RECEIVED_ALL_ATTACHMENTS:
      return {
        ...state,
        attachmentData: action?.payload,
      };
    case actionTypes.RECEIVED_TEMP_MESSAGE_LIST:
      return {
        ...state,
        tempMessageList: action?.payload,
      };
    case actionTypes.REMOVE_TEMP_MESSAGE:
      if (!state?.tempMessageList?.some((m) => m?.temp_timetoken === action?.payload)) return state;
      return {
        ...state,
        tempMessageList: state.tempMessageList.filter((m) => m?.temp_timetoken !== action?.payload),
      };
    case actionTypes.RECEIVED_GROUP_MESSAGE_LIST:
      return {
        ...state,
        messageList: action?.payload,
        cloneGroupMessageList: action?.payload,
      };
    case actionTypes.RECEIVED_OLD_MESSAGE_LIST: {
      const existingTokens = new Set(state?.messageList?.map((m) => m.timetoken));
      const uniqueNew = (action?.payload || []).filter((m) => !existingTokens.has(m.timetoken));
      if (!uniqueNew.length) return state;
      const merged = [...uniqueNew, ...(state?.messageList || [])];
      merged.sort((a, b) => a.timetoken - b.timetoken);
      return { ...state, messageList: merged };
    }
    case actionTypes.MERGE_MESSAGE_LIST: {
      const { messages, activeTopic } = action?.payload || {};
      if (!messages?.length) return state;
      const incomingByToken = new Map(messages.map((m) => [m.timetoken, m]));
      let updatedList = state.messageList.map((m) =>
        incomingByToken.has(m.timetoken) ? { ...m, ...incomingByToken.get(m.timetoken) } : m
      );
      if (activeTopic?.id) {
        updatedList = updatedList.filter((m) => !m.topic_id || m.topic_id === activeTopic.id);
      }
      return { ...state, messageList: updatedList };
    }
    // A read receipt: the reader is added to these messages' read_by wherever
    // they're shown (chat, open thread, Starred), as a re-fetch would.
    case actionTypes.APPLY_READ_RECEIPT: {
      const { temp_timetokens, reader } = action?.payload || {};
      if (!reader || !temp_timetokens?.length) return state;
      const ids = new Set(temp_timetokens);
      let changed = false;
      const withReader = (list) => {
        if (!Array.isArray(list)) return list;
        let listChanged = false;
        const next = list.map((m) => {
          if (!m || !ids.has(m.temp_timetoken)) return m;
          const readBy = Array.isArray(m.read_by) ? m.read_by : [];
          if (readBy.includes(reader)) return m;
          listChanged = true;
          return { ...m, read_by: [...readBy, reader] };
        });
        if (!listChanged) return list;
        changed = true;
        return next;
      };
      const messageList = withReader(state.messageList);
      const threadMsgList = withReader(state.threadMsgList);
      const starMessages = withReader(state.starMsgData?.messages);
      if (!changed) return state;
      return {
        ...state,
        messageList,
        threadMsgList,
        starMsgData: starMessages === state.starMsgData?.messages ? state.starMsgData : { ...state.starMsgData, messages: starMessages },
      };
    }
    // Messages moved to another topic/subtopic: the open view (all, a topic
    // or a subtopic) keeps, drops or gains them, as a new message would be.
    case actionTypes.APPLY_TOPIC_MOVE: {
      const { messages, activeTopicId, activeSubtopicId } = action?.payload || {};
      if (!messages?.length) return state;
      const inView = (m) => {
        if (activeSubtopicId) return (m.subtopic_id || "") === activeSubtopicId;
        if (activeTopicId) return (m.topic_id || "") === activeTopicId;
        return true;
      };
      const moved = new Map(messages.map((m) => [m.temp_timetoken, m]));
      const shown = new Set();
      let list = [];
      (state.messageList || []).forEach((m) => {
        const update = moved.get(m.temp_timetoken);
        if (!update) {
          list.push(m);
          return;
        }
        shown.add(m.temp_timetoken);
        const next = { ...m, topic_id: update.topic_id, subtopic_id: update.subtopic_id };
        if (inView(next)) list.push(next);
      });
      // Moved into this view: add those within the loaded range (older ones
      // load from the local store when scrolling up).
      const oldest = list.length ? Math.min(...list.map((m) => +m.timetoken || Infinity)) : -Infinity;
      messages
        .filter((m) => !shown.has(m.temp_timetoken) && inView(m) && +m.timetoken >= oldest)
        .forEach((m) => {
          const at = list.findIndex((x) => +x.timetoken > +m.timetoken);
          list = at === -1 ? [...list, m] : [...list.slice(0, at), m, ...list.slice(at)];
        });
      return { ...state, messageList: list };
    }
    case actionTypes.REMOVE_FROM_MESSAGE_LIST: {
      const temp_timetoken = action?.payload;
      return {
        ...state,
        messageList: state.messageList.filter((m) => m.temp_timetoken !== temp_timetoken),
      };
    }
    case actionTypes.RECEIVED_GROUP_INSTANT_MESSAGE_LIST: {
      const incoming = action?.payload;
      const isDuplicate = state?.messageList?.some(
        (m) =>
          (incoming?.timetoken && m.timetoken === incoming.timetoken) ||
          (incoming?.temp_timetoken && m.temp_timetoken === incoming.temp_timetoken) ||
          (incoming?.id && m.id === incoming.id)
      );
      if (isDuplicate) return state;
      return {
        ...state,
        messageList: [...state?.messageList, incoming],
        cloneGroupMessageList: incoming,
      };
    }
    case actionTypes.UPDATE_EXISTING_MESSAGE_LIST:
      const index = state?.messageList?.findIndex(
        (obj) => obj.timetoken === action?.payload?.timetoken
      );
      if (index !== -1) {
        const updatedMessages = [...state.messageList];
        updatedMessages[index] = {
          ...updatedMessages[index],
          ...action?.payload,
        };

        return {
          ...state,
          messageList: updatedMessages,
        };
      }
      return state;

    case actionTypes.RECEIVED_THREAD_MESSAGES:
      return {
        ...state,
        threadMsgList: action?.payload,
      };
    case actionTypes.RECEIVED_OLD_THREAD_MESSAGES: {
      const existingTimetokens = new Set(
        state?.threadMsgList?.map((m) => m?.timetoken),
      );
      const olderMessages = (action?.payload || []).filter(
        (m) => !existingTimetokens.has(m?.timetoken),
      );
      return {
        ...state,
        threadMsgList: [...state?.threadMsgList, ...olderMessages],
      };
    }
    case actionTypes.RECEIVED_GROUP_INSTANT_THREAD_MESSAGE_LIST:
      if (
        state?.threadMsgList?.length > 0 &&
        !state?.threadMsgList[0]?.thread_id &&
        state?.threadMsgList[0]?.id === action?.payload?.thread_id
      ) {
        
        return {
          ...state,
          threadMsgList: [...state?.threadMsgList, action?.payload],
        };
      }
      return state;
    case actionTypes.UPDATE_EXISTING_THREAD_MESSAGE:
      const msgindex = state?.threadMsgList?.findIndex(
        (obj) => obj.temp_timetoken === action?.payload?.temp_timetoken
      );
      let updatedMessages = [...state?.threadMsgList];
      if (msgindex !== -1) {
        updatedMessages[msgindex] = {
          ...updatedMessages[msgindex],
          ...action?.payload,
        };
        return {
          ...state,
          threadMsgList: updatedMessages,
        };
      }
      return state;

    case actionTypes.DELETE_EXISTING_THREAD_MESSAGE:
      const filteredMessages = state?.threadMsgList?.filter(
        (obj) => obj.temp_timetoken !== action?.payload
      );
      return {
        ...state,
        threadMsgList: filteredMessages,
      };

    case actionTypes.UPDATE_THREAD_HEADING: {
      const { id, thread_heading } = action.payload;
      const updatedThreadMsgList = state.threadMsgList.map((msg) =>
        msg.id === id ? { ...msg, thread_heading } : msg
      );
      const updatedMessageList = state.messageList.map((msg) =>
        msg.id === id ? { ...msg, thread_heading } : msg
      );
      const updatedWorkTrackingList = state.workTrackingList.map((msg) =>
        msg.id === id ? { ...msg, thread_heading } : msg
      );
      const existingParent = state.workTrackingThreadParents?.[id];
      const updatedThreadParents = existingParent
        ? { ...state.workTrackingThreadParents, [id]: { ...existingParent, thread_heading } }
        : state.workTrackingThreadParents;
      return {
        ...state,
        threadMsgList: updatedThreadMsgList,
        messageList: updatedMessageList,
        workTrackingList: updatedWorkTrackingList,
        workTrackingThreadParents: updatedThreadParents,
      };
    }

    case actionTypes?.RECEIVED_ALL_TASKLIST:
      return {
        ...state,
        taskList: action?.payload,
      };

    case actionTypes?.RECEIVED_OLD_TASKLIST_DATA:
      return {
        ...state,
        taskList: [...state?.taskList, ...action?.payload],
      };

    case actionTypes?.UPDATE_EXISTING_TASK_LIST:
      const updateTaskList = state?.taskList?.filter(
        (obj) => obj.id !== action?.payload?.id
      );
      return {
        ...state,
        taskList: updateTaskList,
      };

    case actionTypes?.UPDATE_EXISTING_TASKLIST_DATA: {
      const updateWTItem = (item) => {
        if (item.timetoken === action.payload.timetoken) {
          return { ...item, ...action.payload };
        }
        if (Array.isArray(item.balah)) {
          return {
            ...item,
            balah: item.balah.map((child) =>
              child.timetoken === action.payload.timetoken
                ? { ...child, ...action.payload }
                : child
            ),
          };
        }
        return item;
      };
      return {
        ...state,
        taskList: state.taskList.map(updateWTItem),
        workTrackingList: (state.workTrackingList || []).map(updateWTItem),
      };
    }


    case actionTypes?.REORDER_TASK_LIST:
      return {
        ...state,
        taskList: action?.payload,
      };

    case actionTypes?.RECEIVED_ALL_APPROVALLIST:
      return {
        ...state,
        approvalList: action?.payload,
      };

    case actionTypes?.UPDATE_EXISTING_APPROVALLIST_LIST:
      const updatedApprovalList = state?.approvalList?.filter(
        (obj) => obj.id !== action?.payload?.id
      );
      return {
        ...state,
        approvalList: updatedApprovalList,
      };

    case actionTypes?.RECEIVED_OLD_APPROVALLIST_DATA:
      return {
        ...state,
        approvalList: [...state?.approvalList, ...action?.payload],
      };

    case actionTypes?.UPDATE_EXISTING_APPROVALLIST_DATA: {
      const incoming = action?.payload;
      const mergeApproval = (item) => {
        if (item.timetoken !== incoming?.timetoken) return item;
        return {
          ...item,
          ...incoming,
          chain:
            incoming?.chain && typeof incoming.chain === "object"
              ? incoming.chain
              : item?.chain,
        };
      };
      const approvalIndex = state?.approvalList?.findIndex(
        (obj) => obj.timetoken === incoming?.timetoken
      );
      const updatedApprovalList =
        approvalIndex !== -1
          ? state.approvalList.map(mergeApproval)
          : state.approvalList;
      const wtIndex = (state.workTrackingList || []).findIndex(
        (obj) => obj.timetoken === incoming?.timetoken
      );
      const updatedWorkTrackingListAppr =
        wtIndex !== -1
          ? state.workTrackingList.map(mergeApproval)
          : state.workTrackingList;
      return {
        ...state,
        approvalList: updatedApprovalList,
        workTrackingList: updatedWorkTrackingListAppr,
      };
    }

    case actionTypes?.PREPEND_TO_APPROVALLIST: {
      const incoming = action.payload;
      const alreadyExists = state?.approvalList?.some(
        (a) =>
          a.timetoken === incoming?.timetoken ||
          (incoming?.temp_timetoken &&
            a.temp_timetoken === incoming?.temp_timetoken)
      );
      if (alreadyExists) return state;

      // chain may arrive as a plain ID or a partially-hydrated object from PubNub.
      // Always prefer the fully-decrypted version already in the store.
      let resolvedChain = incoming?.chain;
      if (resolvedChain) {
        const chainId =
          typeof resolvedChain === "object" ? resolvedChain.id : resolvedChain;
        if (chainId) {
          resolvedChain =
            state.approvalList.find((a) => a.id === chainId) || resolvedChain;
        }
      }

      return {
        ...state,
        approvalList: [{ ...incoming, chain: resolvedChain }, ...state.approvalList],
      };
    }

    case actionTypes?.RECEIVED_ALL_WORK_TRACKING_LIST:
      return {
        ...state,
        workTrackingList: action?.payload,
        workTrackingThreadParents: {},
      };

    case actionTypes?.RECEIVED_OLD_WORK_TRACKING_DATA:
      return {
        ...state,
        workTrackingList: [...(state?.workTrackingList || []), ...action?.payload],
      };

    case actionTypes?.MERGE_WORK_TRACKING_THREAD_PARENTS:
      return {
        ...state,
        workTrackingThreadParents: { ...state.workTrackingThreadParents, ...action.payload },
      };

    case actionTypes?.RECEIVED_ALL_TASKANALYTICS_DATA:
      return {
        ...state,
        taskAnalyticsData: action?.payload,
      };
    case actionTypes?.RECEIVED_ALL_APPROVALANALYTICS_DATA:
      return {
        ...state,
        approvalAnalyticsData: action?.payload,
      };

    case actionTypes?.GET_ALL_SELLER_TAB_POSTS:
      return {
        ...state,
        sellerPostList: action?.payload,
      };
    case actionTypes?.GET_AI_HISTORY_DONE:
      return {
        ...state,
        aiHistoryData: action?.payload,
      };
    case actionTypes?.GET_QUERY_ANSWER_DONE:
      return {
        ...state,
        aiQuerySession: [...state?.aiQuerySession, action?.payload],
      };
    case actionTypes?.GET_EDIT_ANSWER_DONE:
      const aiDataIdindex = state?.aiQuerySession?.findIndex(
        (obj) => obj.id === action?.payload?.id
      );
      if (aiDataIdindex !== -1) {
        const updatedAiAnswer = [...state.aiQuerySession];
        updatedAiAnswer[aiDataIdindex] = {
          ...updatedAiAnswer[aiDataIdindex],
          ...action?.payload,
        };

        return {
          ...state,
          aiQuerySession: updatedAiAnswer,
        };
      }
      return state;

    case actionTypes?.CLEAR_CURRENT_AI_SESSION_DATA:
      return {
        ...state,
        aiQuerySession: [],
      };
    case actionTypes.REQUEST_GET_ALLSTAR_MESSAGE:
      return {
        ...state,
        starMsgData: action?.payload,
      };
    case actionTypes?.CREATE_POST_DONE:
      return {
        ...state,
        postPreviewData: action?.payload,
      };
    case actionTypes.GET_ALL_BRAND_LIST_DONE:
      return {
        ...state,
        brandDataList: {
          data: action?.payload,
        },
      };
    case actionTypes.GET_ALL_ARTISTS_LIST_DONE:
      return {
        ...state,
        artistDataList: {
          data: action?.payload,
        },
      };
    case actionTypes.GET_ALL_POST_LIST_DONE:
      return {
        ...state,
        postDataList: {
          data: action?.payload,
        },
      };
    case actionTypes.GET_MY_FEED_POSTS:
      return {
        ...state,
        myFeedPostList: {
          data: action?.payload,
        },
      };
    case actionTypes.GET_ALL_POST_LIST_EXPLORE_DONE:
      return {
        ...state,
        exploreDataList: action?.payload,
      };
    case actionTypes.GET_OLD_POST_DATA_EXPLORE_DONE:
      const { count, posts } = action?.payload || {};
      return {
        ...state,
        exploreDataList: {
          count, // The updated post count from the new data
          posts: [...(state.exploreDataList.posts || []), ...posts], // Combine previous posts with new ones
        },
      };

    case actionTypes.GET_LIKE_USER_LIST:
      return {
        ...state,
        likeUserList: action?.payload,
      };

    case actionTypes.EDIT_POST_LIST_EXPLORE:
      const explorePostIdIndex = state?.exploreDataList?.posts?.findIndex(
        (obj) => obj.id === action?.payload
      );
      if (explorePostIdIndex !== -1) {
        const updatedPostData = [...state.exploreDataList?.posts];
        updatedPostData[explorePostIdIndex] = {
          ...updatedPostData[explorePostIdIndex],
          isLiked: !updatedPostData[explorePostIdIndex]?.isLiked,
        };
        return {
          ...state,
          exploreDataList: { ...state.exploreDataList, posts: updatedPostData },
        };
      }
      return state;
    default:
      return state;
  }
};
